import script from "./leftMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./leftMenu.vue?vue&type=script&lang=ts&setup=true"

import "./leftMenu.vue?vue&type=style&index=0&id=0f4fd408&lang=scss&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\inspectionSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f4fd408"]])

export default __exports__